<template>
  <div>
	  <div class="page">
			<div class="logo anim-item anim-logo">
				<img src="../assets/logo.png" alt="" />
			</div>
				
	  		<div class="slogen anim-item anim-slogen">
				<img src="../assets/slogen.png" alt="" />
			</div>
			
			<router-link to="login"  class="btn-enter fcc anim-item anim-btn">
				<img src="../assets/enter-btn.png" alt="欢迎登录" />
			</router-link>
			
	  </div>
	  
 

	 <van-overlay :show="showLoading"  >
		<div class="fcc-h " style="height: 100vh;">
			<van-loading size="24px" vertical color="#fff">加载中...</van-loading>
		</div>
	 </van-overlay>


  </div>
</template>

<script>


export default {

  data() {
    return {
		
        showLoading:false,
       
    };
  },
  async mounted() {
	this.uid = window.localStorage.getItem('cscec2026UserId')
	if (this.uid && this.uid != '1' && this.uid != 1) {
		this.$router.push({ path: '/task-guide' })
	}

    // this.showLoading=true

    // const loading = this.$toast.loading({
    //   mask: true,
    //   message: '加载中...',
    //   duration:0
    // });
	


  },
  methods: {
    
    
  },
};
</script>
<style  scoped lang="less">
	.page{
		display: flex;
		flex-direction: column;
		min-height: 100vh;
		background:url(../assets/homebg.png) center no-repeat;
		background-size: cover;
	}

	/* Apple-style staggered entrance animations */
	.anim-item {
		opacity: 0;
		animation-fill-mode: both;
		animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
	}

	.anim-logo {
		animation: fadeSlideDown 0.8s 0.2s both;
	}

	.anim-slogen {
		animation: fadeSlideUp 0.9s 0.5s both;
	}

	.anim-btn {
		animation: fadeSlideUp 0.9s 0.8s both;
	}

	@keyframes fadeSlideDown {
		from {
			opacity: 0;
			transform: translateY(-24px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes fadeSlideUp {
		from {
			opacity: 0;
			transform: translateY(24px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* Subtle breathing on button after entrance */
	.anim-btn {
		animation: fadeSlideUp 0.9s 0.8s both, breathe 3s 1.8s ease-in-out infinite;
	}

	@keyframes breathe {
		0%, 100% {
			transform: scale(1);
			filter: brightness(1);
		}
		50% {
			transform: scale(1.03);
			filter: brightness(1.05);
		}
	}

	.btn-enter{
		img{
			width: 100%;
			height: auto;
			display: block;
		}
	}
	
</style>

